/* Portal configurations - global scope */

/* Define a product types for the portal.
* id: product type's id
* name: product type's name
* available:
*/
const helper = {};

const accent_color = 'version2'; // color schema of the portal

const portal_name = 'Vemoplay';

const activate_website = 1; // 1(all), 2(only portal), 3(only landing)

const landing_name = "Vemoplay"; // FirstPortal, EbookPortal

const product_type = 4;

const portal_url = "vemoplay.com";

const country_landing_url = [{
  'UK': 'https://premium.vemoplay.com/hEVfsX/',
  'EE': 'https://premium.vemoplay.com/apSxdQ/',
  'LV': 'https://premium.vemoplay.com/47mbCP/',
  'LT': 'https://premium.vemoplay.com/lT78Vp/mo/',
  'SK': 'https://premium.vemoplay.com/VPoA01/mo/',
  'RO': 'https://premium.vemoplay.com/VpRo01/',
  'FI': 'https://premium.vemoplay.com/BUvnnE/',
  'DK': 'https://premium.vemoplay.com/9K07iK/',
  'SE': 'https://premium.vemoplay.com/GNuxej/',
  'PL': 'https://premium.vemoplay.com/N5tLjN/',
  'CH': 'https://premium.vemoplay.com/VpCh69/',
  'CZ': 'https://premium.vemoplay.com/UiQa01/',
  'LU': 'https://premium.vemoplay.com/K6HsmP/',
  'ME': 'https://premium.vemoplay.com/mEVp08/',
  'BA': 'https://premium.vemoplay.com/0t01yW/'
}];

const country_default_language = {
  'UK': 'EN',
  'LU': 'EN',
  'CH': 'DE',
  'ME': 'BA',
  'LT': 'LT'
};

const product_menu_items = [{
  id: 1,
  name: 'Home',
  available: 1,
  type: 4,
  banner: 0,
  isActive: true,
  countryExclusion: ''
},
  {
    id: 2,
    name: 'Online Games',
    available: 1,
    type: 1,
    banner: 0,
    isActive: false,
    countryExclusion: ''
  },
  {
    id: 3,
    name: 'Android Games Apps',
    available: 1,
    type: 2,
    banner: 0,
    isActive: false,
    countryExclusion: ''
  },
  {
    id: 6,
    name: 'Apps',
    available: 0,
    type: 6,
    banner: 0,
    isActive: false,
    countryExclusion: ''
  },
  {
    id: 5,
    name: 'Funny Videos',
    available: 0,
    type: 5,
    banner: 0,
    isActive: false,
    countryExclusion: 'SK'
  },
  {
    id: 7,
    name: 'Fitness',
    available: 0,
    type: 7,
    banner: 0,
    isActive: false,
    countryExclusion: 'SK'
  }
];

const language_phones_format = {
  UK: '+44xxxxxxxxx',
  FI: '04xxxxxxxx',
  EE: '5xxxxxxx',
  LV: '2xxxxxxx',
  LT: '6xxxxxxx',
  RO: '07xxxxxxxx',
  SK: '09xxxxxxxx',
  DK: '47xxxxxxxxx',
  SE: '07xxxxxxxx',
  PL: 'xxxxxxxxx',
  CH: '07xxxxxxxx',
  RS: '06xxxxxxxx',
  CZ: '7xxxxxxxx',
  LU: '352xxxxxxxxx',
  SI: '386xxxxxxxx',
  ME: '06xxxxxxx',
  BA: '06xxxxxxx',
    PT: '09xxxxxxx'
};

/*
 * Rating and Favourite feature enabled (1, 0)
 */
const use_rating = 1;
const use_favourite = 1;

// API Base URL
//prod
const API_BASE_URL = 'https://api.hubdelivery.io';
//local
// const API_BASE_URL = 'http://localhost:5001';

// apis
helper.api_PhoneNumber = `${API_BASE_URL}/landing/providePhoneNumberV2`;
helper.api_ValidatePin = `${API_BASE_URL}/landing/validatePinCodeV2`;
helper.api_SendAccessCodeByEmail = `${API_BASE_URL}/landing/sendAccessCodeByEmail`;

helper.api_Search = `${API_BASE_URL}/store/searchProducts`;

// tracking api url
helper.ratingsAPI = `${API_BASE_URL}/store/addProductRating`;
helper.favouriteAPI = `${API_BASE_URL}/store/addToFavourite`;
helper.favouriteRemoveAPI = `${API_BASE_URL}/store/removeFromFavourite`;

// Export API_BASE_URL for use in other components
helper.API_BASE_URL = API_BASE_URL;

// Export API_BASE_URL for use in other components
helper.API_BASE_URL = API_BASE_URL;

// tracking default and generated values
helper.affiliate_landing = 'AFFED8bcEzc'; // aff
helper.source_landing = '997PROVID998'; // src
helper.landing_page_id = 'LPC9crQndF8'; // lpc

// apis
helper.landingUrl = country_landing_url;
helper.languagePhoneFormat = language_phones_format;
helper.countryDefaultLanguage = country_default_language;
helper.menu = product_menu_items;
helper.portal_name = portal_name;
helper.portal_type = product_type;
helper.landing_name = landing_name;
helper.portal_url = portal_url;
helper.accent_color = accent_color;
helper.actice_website = activate_website;
helper.hasStars = use_rating;
helper.hasFavourite = use_favourite;

export const helpers = helper;
